import { render, staticRenderFns } from "./QuestionGroupComponent.vue?vue&type=template&id=4f07eb09&scoped=true"
import script from "./QuestionGroupComponent.vue?vue&type=script&lang=js"
export * from "./QuestionGroupComponent.vue?vue&type=script&lang=js"
import style0 from "./QuestionGroupComponent.vue?vue&type=style&index=0&id=4f07eb09&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f07eb09",
  null
  
)

export default component.exports